export const formJson = {
    "step3": {
        pageTitle: "",
        getDataKey: "employee_personal_details",
        apiEndpoint: "UPSERTEMPLOYEINFODATA",
        fieldData: {
            "Personal Details": {
                key: "employee_personal_details",
                payload: {
                    "birth_place_city_item_name": "",
                    "birth_place_state_item_name": "",
                    "nationality_item_name": "",
                    "religion_item_name": "",
                    "height_feet_inches": 0,
                    "weight_in_kgs": 0,
                    "marital_status_item_id": 0,
                    "family_id": 0,
                    "blood_group_item_id": 0,
                    "identification_mark": "",
                    "personal_emailid": "",
                    "uan_number": "",
                    "cast_item_name": "",
                    "sub_cast_item_name": "",
                    "is_physically_handicapped": false,
                    "nature_of_disability": "",
                    "user_photograph_file_id": "",
                    "user_signature_file_id": "",
                    "user_resume_file_id": "",
                    "employment_item_id": "",
                },
                inputs: [
                    {
                        label: "Name",
                        name: "user_display_name",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Designation",
                        name: "designation",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Date of Joining",
                        name: "joining_date",
                        col: "3",
                        type: "date",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Location",
                        name: "job_location",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Business Unit / Function",
                        name: "business_unit",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Sub Business Unit / Function",
                        name: "sub_business_unit",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Gender",
                        name: "gender",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Date of Birth",
                        name: "birth_date",
                        col: "3",
                        type: "date",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Place of Birth City",
                        name: "birth_place_city_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "city"
                    },
                    {
                        label: "Place of Birth State",
                        name: "birth_place_state_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "state"
                    },
                    {
                        label: "Nationality",
                        name: "nationality_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "nationality"
                    },
                    {
                        label: "Religion",
                        name: "religion_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "religion"
                    },
                    {
                        label: "Height (in feet & inches)",
                        name: "height_feet_inches",
                        col: "3",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Weight (in Kgs)",
                        name: "weight_in_kgs",
                        col: "3",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Marital Status",
                        name: "marital_status_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "marital_status"
                    },
                    {
                        label: "Spouse Name",
                        name: "spouse_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "marital_status"
                    },
                    {
                        label: "Marriage Anniversary Date",
                        name: "marriage_date",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "marital_status"
                    },
                    {
                        label: "Blood Group",
                        name: "blood_group_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "blood_group"
                    },
                    {
                        label: "Identification Mark",
                        name: "identification_mark",
                        col: "3",
                        type: "text",
                        required: false
                    },
                    {
                        label: "Official Email Id",
                        name: "email_id",
                        col: "3",
                        type: "text",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "Personal Email id",
                        name: "personal_emailid",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "UAN Number",
                        name: "uan_number",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Offer Letter Date",
                        name: "offer_later_date",
                        col: "3",
                        type: "date",
                        required: true,
                        disabled: true
                    },
                    {
                        label: "The category to which you belong",
                        name: "cast_item_name",
                        col: "5",
                        type: "autocomplete",
                        required: false,
                        option: [],
                        optionType: "caste"
                    },
                    {
                        label: "Sub Caste",
                        name: "sub_cast_item_name",
                        col: "2",
                        type: "autocomplete",
                        required: false,
                        option: [],
                        optionType: "sub_caste"
                    },
                    {
                        label: "Type of employment for which you are selected",
                        name: "employment_item_id",
                        col: "5",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "employment_type"
                    },
                    {
                        label: "Whether Physically Handicapped",
                        name: "is_physically_handicapped",
                        col: "5",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    },
                    {
                        label: "If Yes Nature of Disability",
                        name: "nature_of_disability",
                        col: "2",
                        type: "text",
                        required: false
                    },
                    {
                        label: "Photograph",
                        name: "user_photograph_file",
                        col: "3",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Signature",
                        name: "user_signature_file",
                        col: "3",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Upload Resume",
                        name: "user_resume_file",
                        col: "3",
                        type: "file",
                        required: true,
                        fileType: "image"
                    },
                ]
            },
            "Emergency Contact Details": {
                key: "employee_emergency_details",
                payload: {
                    "emergency_contact_person_name": "",
                    "emergency_contact_number": "",
                    "emergency_contact_relation_item_id": 0,
                    "emergency_address_data": "",
                },
                inputs: [
                    {
                        label: "Name of the person",
                        name: "emergency_contact_person_name",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Contact Number",
                        name: "emergency_contact_number",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Relationship",
                        name: "emergency_contact_relation_item_id",
                        col: "4",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "relationship"
                    },
                    {
                        label: "Address",
                        name: "emergency_address_data",
                        col: "4",
                        type: "textarea",
                        required: true
                    },
                ],
            },
            "Contact Information": {
                key: "employee_contact_details",
                payload: {
                    "present_contact_address": "",
                    "present_contact_pincode": "",
                    "present_contact_mobile_number": "",
                    "present_contact_residence_number": "",
                    "permanent_contact_address": "",
                    "permanent_contact_pincode": "",
                    "permanent_contact_mobile_number": "",
                    "permanent_contact_residence_number": ""
                },
                inputs: [
                    {
                        label: "Permanent Address",
                        name: "permanent_contact_address",
                        col: "12",
                        type: "textarea",
                        required: true
                    },
                    {
                        label: "Pincode",
                        name: "permanent_contact_pincode",
                        col: "6",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Residence No (Tel/Mobile)",
                        name: "permanent_contact_residence_number",
                        col: "6",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Mobile No",
                        name: "permanent_contact_mobile_number",
                        col: "6",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Present Address",
                        name: "present_contact_address",
                        col: "12",
                        type: "textarea",
                        required: true
                    },
                    {
                        label: "Pincode",
                        name: "present_contact_pincode",
                        col: "6",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Residence No (Tel/Mobile)",
                        name: "present_contact_residence_number",
                        col: "6",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Mobile No",
                        name: "present_contact_mobile_number",
                        col: "6",
                        type: "text",
                        required: true
                    },
                ]
            }
        },
    },
    "step4": {
        pageTitle: "",
        getDataKey: "employee_education_details",
        fieldData: {
            "Educational Details (Mention latest to old)": {
                key: "employee_education_details",
                apiEndpoint: "UPSERTEMPLOYEEEDUCATIONDETAILS",
                deleteKey: "education_details_delete",
                payload: {
                    "education_id": 0,
                    "education_item_name": "",
                    "from_year": 0,
                    "to_year": 0,
                    "name_of_college_university": "",
                    "location_item_name": "",
                    "main_subject_item_name": "",
                    "mark_grade": "",
                    "certificate_file_id": ""
                },
                inputs: [
                    {
                        label: "Degree",
                        name: "education_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "edcutaion_degree",
                    },
                    {
                        label: "From Year",
                        name: "from_year",
                        col: "3",
                        type: "year",
                        required: true
                    },
                    {
                        label: "To Year",
                        name: "to_year",
                        col: "3",
                        type: "year",
                        required: true
                    },
                    {
                        label: "Name of School / College / University",
                        name: "name_of_college_university",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Location",
                        name: "location_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "city"
                    },
                    {
                        label: "Main Subjects",
                        name: "main_subject_item_name",
                        col: "3",
                        type: "autocomplete",
                        required: true,
                        option: [],
                        optionType: "subject"
                    },
                    {
                        label: "Marks (%) / Grade",
                        name: "mark_grade",
                        col: "3",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Marksheet/Certificate upload",
                        name: "certificate_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                ]
            }
        }
    },
    "step5": {
        getDataKey: "employee_family_and_language_details",
        fieldData: {
            "Family Background": {
                key: "employee_family_details",
                apiEndpoint: "UPSERTEMPLOYEEFAMILYDETAILSDATA",
                deleteKey: "family_details_delete",
                payload: {
                    "family_id": 0,
                    "member_name": "",
                    "relationship_item_id": 0,
                    "date_of_birth": "",
                    "gender_item_id": 0,
                    "marital_status_item_id": 0,
                    "education_item_name": "",
                    "occupation_item_name": ""
                },
                inputs: [
                    {
                        label: "Name (Full Name)",
                        name: "member_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Relationship",
                        name: "relationship_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "relationship",
                        tableField: "relation_name"
                    },
                    {
                        label: "Date of Birth",
                        name: "date_of_birth",
                        col: "3",
                        type: "date",
                        required: true
                    },
                    {
                        label: "Gender",
                        name: "gender_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "gender",
                        tableField: "gender"
                    },
                    {
                        label: "Marital Status",
                        name: "marital_status_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "marital_status",
                        tableField: "marital_status"

                    },
                    {
                        label: "Education",
                        name: "education_item_name",
                        col: "3",
                        type: "autocomplete",
                        option: [],
                        optionType: "edcutaion_degree",
                    },
                    {
                        label: "Occuption",
                        name: "occupation_item_name",
                        col: "3",
                        type: "autocomplete",
                        option: [],
                        optionType: "occupation",
                    },

                ]
            },
            "Language Known By Employee": {
                key: "employee_language_details",
                apiEndpoint: "UPSERTEMPLOYEELANGUAGEKNOWDATA",
                deleteKey: "language_details_delete",
                payload: {
                    "language_id": 0,
                    "language_item_id": 0,
                    "is_read": true,
                    "is_write": true,
                    "is_speak": true
                },
                inputs: [
                    {
                        label: "Language",
                        name: "language_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "language",
                        tableField: "language_name"
                    },
                    {
                        label: "Read",
                        name: "is_read",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "auto_drop_down",
                        tableField: "is_read_name"
                    },
                    {
                        label: "Write",
                        name: "is_write",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "auto_drop_down",
                        tableField: "is_write_name"
                    },
                    {
                        label: "Speak",
                        name: "is_speak",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "auto_drop_down",
                        tableField: "is_speak_name"
                    },

                ]
            }
        }
    },
    "step6": {
        pageTitle: "Employee KYC Details",
        getDataKey: "employee_kyc_bank_passport_prior_assosciation_details",
        fieldData: {
            "PAN Card Details: (As mentioned on Pan Card)": {
                key: "employee_kyc_pan_card_details",
                apiEndpoint: "UPSERTEMPLOYEEKYCDOCUMENTDETAILS",
                payload: {
                    "kyc_document_id": 0,
                    "document_item_id": 0,
                    "document_number": "",
                    "name_on_document": "",
                    "date_of_birth": "",
                    "father_husband_name": "",
                    "address_on_document": "",
                    "relationship_item_id": 0,
                    "gender_item_id": 0,
                    "document_issue_date": "",
                    "document_expire_date": "",
                    "document_front_file_id": "",
                    "document_back_file_id": "",
                    "is_valid_passport": false

                },
                inputs: [
                    {
                        label: "PAN No",
                        name: "document_number",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Full Name",
                        name: "name_on_document",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Date of Birth",
                        name: "date_of_birth",
                        col: "4",
                        type: "date",
                        required: true
                    },
                    {
                        label: "Father / Mother / Husband Name",
                        name: "father_husband_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Relation",
                        name: "relationship_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "relationship"
                    },
                    {
                        label: "Documnet Front side",
                        name: "document_front_file",
                        col: "3",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Documnet Back side",
                        name: "document_back_file",
                        col: "3",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        optionKey: "pan_card"
                    }
                ]
            },
            "Aadhar Card Details : (As mentioned on Aadhaar Card)": {
                key: "employee_kyc_aadhar_card_details",
                apiEndpoint: "UPSERTEMPLOYEEKYCDOCUMENTDETAILS",
                payload: {
                    "kyc_document_id": 0,
                    "document_item_id": 0,
                    "document_number": "",
                    "name_on_document": "",
                    "date_of_birth": "",
                    "father_husband_name": "",
                    "address_on_document": "",
                    "relationship_item_id": 0,
                    "gender_item_id": 0,
                    "document_issue_date": "",
                    "document_expire_date": "",
                    "document_front_file_id": "",
                    "document_back_file_id": "",
                    "is_valid_passport": false,

                },
                inputs: [
                    {
                        label: "Aadhaar Card No:",
                        name: "document_number",
                        col: "4",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Full Name",
                        name: "name_on_document",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Date of Birth",
                        name: "date_of_birth",
                        col: "4",
                        type: "date",
                        required: true
                    },
                    {
                        label: "Father / Mother / Husband Name",
                        name: "father_husband_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Relation",
                        name: "relationship_item_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "relationship"
                    },
                    {
                        label: "Gender",
                        name: "gender_item_id",
                        col: "2",
                        type: "select",
                        required: true,
                        option: [],
                        optionType: "gender"
                    },
                    {
                        label: "Documnet Front side",
                        name: "aadhar_front_file",
                        col: "2",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Documnet Back side",
                        name: "aadhar_back_file",
                        col: "2",
                        type: "file",
                        required: true,
                    },

                    {
                        label: "Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        optionKey: "aadhar_card"

                    }
                ]
            },
            "Driving Licence Details : (As mentioned on Driving Licence)": {
                key: "employee_kyc_driving_licence_details",
                apiEndpoint: "UPSERTEMPLOYEEKYCDOCUMENTDETAILS",
                payload: {
                    "kyc_document_id": 0,
                    "document_item_id": 0,
                    "document_number": "",
                    "name_on_document": "",
                    "date_of_birth": "",
                    "father_husband_name": "",
                    "address_on_document": "",
                    "relationship_item_id": 0,
                    "gender_item_id": 0,
                    "document_issue_date": "",
                    "document_expire_date": "",
                    "document_front_file_id": "",
                    "document_back_file_id": "",
                    "is_valid_passport": false

                },
                inputs:
                    [
                        {
                            label: "Driving Licence Number",
                            name: "document_number",
                            col: "3",
                            type: "number",
                            required: true
                        },
                        {
                            label: "Full Name",
                            name: "name_on_document",
                            col: "3",
                            type: "text",
                            required: true
                        },
                        {
                            label: "Date of Birth",
                            name: "date_of_birth",
                            col: "3",
                            type: "date",
                            required: true
                        },
                        {
                            label: " Residential Address:",
                            name: "address_on_document",
                            col: "3",
                            type: "text",
                            required: true
                        },
                        {
                            label: "Issue Date",
                            name: "document_issue_date",
                            col: "3",
                            type: "date",
                            required: true
                        },
                        {
                            label: "End Date",
                            name: "document_expire_date",
                            col: "3",
                            type: "date",
                            required: true
                        },

                        {
                            label: "Documnet Front side",
                            name: "driving_front_file",
                            col: "3",
                            type: "file",
                            required: true,
                        },
                        {
                            label: "Documnet Back side",
                            name: "driving_back_file",
                            col: "3",
                            type: "file",
                            required: true,
                        },
                        {
                            label: "Save",
                            name: "btn",
                            col: 12,
                            type: "button",
                            optionKey: "driving_licence"
                        }
                    ]
            },
            "Bank Details : (As mentioned on Bank Pass Book)": {
                key: "employee_kyc_bank_details",
                apiEndpoint: "UPSERTEMPLOYEEBANKDETAILS",
                payload: {
                    "bank_item_id": 0,
                    "bank_full_name": "",
                    "bank_account_number": "",
                    "bank_ifsc_code": "",
                    "bank_branch_location": "",
                    "bank_statement_file_id": "",
                    "is_valid_passport": false,
                },
                inputs: [
                    {
                        label: "Name of Bank",
                        name: "bank_name",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Full Name",
                        name: "bank_full_name",
                        col: "4",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Bank Account Number",
                        name: "bank_account_number",
                        col: "4",
                        type: "number",
                        required: true
                    },
                    {
                        label: "IFSC Code:",
                        name: "bank_ifsc_code",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Branch Address Location:",
                        name: "bank_branch_location",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Bank Passbook first Page/Statement/ Cheque-File Upload",
                        name: "bank_statement_file",
                        col: "3",
                        type: "file",
                        required: true,
                    },
                    {
                        label: "Save",
                        name: "btn",
                        col: 12,
                        type: "button"
                    }
                ]
            },
            "Passport Details: (As mentioned on Passport)": {
                key: "employee_kyc_passport_details",
                apiEndpoint: "UPSERTEMPLOYEEKYCDOCUMENTDETAILS",
                payload: {
                    "kyc_document_id": 0,
                    "document_item_id": 0,
                    "document_number": "",
                    "name_on_document": "",
                    "date_of_birth": "",
                    "father_husband_name": "",
                    "address_on_document": "",
                    "relationship_item_id": 0,
                    "gender_item_id": 0,
                    "document_issue_date": "",
                    "document_expire_date": "",
                    "document_front_file_id": "",
                    "document_back_file_id": "",
                    "is_document_front": false,
                    "is_document_back": false,
                    "is_valid_passport": false

                },
                inputs: [
                    {
                        label: "Do you have valid Passport ?",
                        name: "is_valid_passport",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "Passport No",
                        name: "document_number",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_valid_passport"
                    },
                    {
                        label: "Full Name",
                        name: "name_on_document",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_valid_passport"
                    },
                    {
                        label: "Date of Birth",
                        name: "date_of_birth",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_valid_passport"
                    },
                    {
                        label: "Issue Date ",
                        name: "document_issue_date",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_valid_passport"
                    },
                    {
                        label: "End Date",
                        name: "document_expire_date",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_valid_passport"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_valid_passport",
                        optionKey: "passport"
                    }
                ]
            },
            "Visa Details: (As mentioned on Visa)": {
                key: "employee_kyc_visa_details",
                apiEndpoint: "UPSERTEMPLOYEEVISADETAILS",
                payload: {
                    "is_valid_visa": false,
                    "visa_type": "",
                    "visa_validity": ""
                },
                inputs: [
                    {
                        label: "Do you have valid Visa ? ",
                        name: "is_valid_visa",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "Visa Type",
                        name: "visa_type",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_valid_visa"
                    },
                    {
                        label: "Visa Validity",
                        name: "visa_validity",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_valid_visa"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_valid_visa"
                    }
                ]
            },
            "PRIOR ASSOCIATION": {
                apiEndpoint: "UPSERTEMPLOYEEPRIORASSOCIATIONDATA",
                key: "prior_association_1",
                payload: {
                    "prior_association_id": 0,
                    "is_prev_emp_associates": false,
                    "association_name": "",
                    "association_position": "",
                    "association_location": "",
                    "joining_date": "",
                    "resignation_date": "",
                    "reason_for_leaving": "",
                    "is_prev_interview": false,
                    "interview_details": "",
                    "is_affiliated": false,
                    "affiliated_details": "",
                    "job_source_item_id": 0,
                    "is_criminal_prosecution": false,
                    "criminal_prosecution_details": "",
                    "is_disciplinary_action": false,
                    "disciplinary_action_details": "",
                    "is_relative_in_company": false,
                    "relative_name": "",
                    "relationship_name": '',
                    "designation_name": "",
                    "company_name": ""
                },
                inputs: [
                    {
                        label: "1. Have you ever worked with SRKAY CONSULTING GROUP or any of its Associate Companies before? ",
                        name: "is_prev_emp_associates",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "Name Of Company",
                        name: "association_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Position",
                        name: "association_position",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Location",
                        name: "association_location",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Entry Date",
                        name: "joining_date",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Exit Date",
                        name: "resignation_date",
                        col: "3",
                        type: "date",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Reason For Leaving",
                        name: "reason_for_leaving",
                        col: "6",
                        type: "text",
                        required: true,
                        depand: "is_prev_emp_associates"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_prev_emp_associates",
                    },
                    {
                        label: "2. Have you ever been interviewed by us for any other position?",
                        name: "is_prev_interview",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "If Yes than please give details",
                        name: "interview_details",
                        col: "6",
                        type: "text",
                        required: true,
                        depand: "is_prev_interview"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_prev_interview"
                    },
                    {
                        label: "3. Are you a member of any professional society/social and culture association,political party,educational or any other society or group ?",
                        name: "is_affiliated",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "If Yes than please give details",
                        name: "affiliated_details",
                        col: "6",
                        type: "text",
                        required: true,
                        depand: "is_affiliated"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_affiliated"
                    },
                    {
                        label: "4. How did you learn about this position?",
                        name: "job_source_item_id",
                        col: "6",
                        type: "select",
                        required: false,
                        option: [],
                        optionType: "source_of_job",
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: "6",
                        type: "button",
                    },
                    {
                        label: "5. Have you been criminally prosecuted?",
                        name: "is_criminal_prosecution",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "If Yes than please give details",
                        name: "criminal_prosecution_details",
                        col: "4",
                        type: "text",
                        required: true,
                        depand: "is_criminal_prosecution"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_criminal_prosecution"
                    },
                    {
                        label: "6. Has any disciplinary action initiated against you in any of your previous employement?",
                        name: "is_disciplinary_action",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "If Yes than please give details",
                        name: "disciplinary_action_details",
                        col: "4",
                        type: "text",
                        required: true,
                        depand: "is_disciplinary_action"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_disciplinary_action"
                    },
                ]
            },
            "ACQUAINTANCES/RELATIVES WORKING IN THE COMPANY": {
                apiEndpoint: "UPSERTEMPLOYEEPRIORASSOCIATIONDATA",
                key: "relative_data",
                payload: {
                    "prior_association_id": 0,
                    "is_prev_emp_associates": false,
                    "association_name": "",
                    "association_position": "",
                    "association_location": "",
                    "joining_date": "",
                    "resignation_date": "",
                    "reason_for_leaving": "",
                    "is_prev_interview": false,
                    "interview_details": "",
                    "is_affiliated": false,
                    "affiliated_details": "",
                    "job_source_item_id": 0,
                    "is_criminal_prosecution": false,
                    "criminal_prosecution_details": "",
                    "is_disciplinary_action": false,
                    "disciplinary_action_details": "",
                    "is_relative_in_company": false,
                    "relative_name": "",
                    "relationship_name": '',
                    "designation_name": "",
                    "company_name": ""
                },
                inputs: [
                    {
                        label: "Is any relative working in the company ? ",
                        name: "is_relative_in_company",
                        col: "12",
                        type: "switch",
                        required: false
                    },
                    {
                        label: "Name",
                        name: "relative_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_relative_in_company"
                    },
                    {
                        label: "Relationship",
                        name: "relationship_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_relative_in_company"
                    },
                    {
                        label: "Particulars(i.e. Position held etc.)",
                        name: "designation_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_relative_in_company"
                    },
                    {
                        label: "Company",
                        name: "company_name",
                        col: "3",
                        type: "text",
                        required: true,
                        depand: "is_relative_in_company"
                    },
                    {
                        label: "Save/Update",
                        name: "btn",
                        col: 12,
                        type: "button",
                        depand: "is_relative_in_company"
                    }
                ]
            },
            "REFERENCE CHECK-Please give atlest two references whom we can refer for verfication": {
                isFormTable: true,
                key: "refrence_check",
                apiEndpoint: "UPSERTEMPLOYEEREFERENCEDETAIL",
                deleteKey: "reference_details_delete",
                payload: {
                    "reference_id": 0,
                    "reference_name": "",
                    "designation_name": "",
                    "company_name": "",
                    "address_data": "",
                    "mobile_number": "",
                    "emailId": ""
                },
                inputs: [
                    {
                        label: "Name",
                        name: "reference_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Designation",
                        name: "designation_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Organization",
                        name: "company_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Address",
                        name: "address_data",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Tel/Mobile",
                        name: "mobile_number",
                        col: "3",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Email id",
                        name: "emailId",
                        col: "3",
                        type: "text",
                        required: true
                    },
                ]
            }

        },
    },
    "step8": {
        pageTitle: "",
        getDataKey: "employee_work_experience",
        fieldData: {
            "Work Experience": {
                key: "employee_work_experience",
                apiEndpoint: "UPSERTEMPLOYEEWORKEXPERIENCEDETAIL",
                deleteKey: "experience_details_delete",
                payload: {
                    "experience_id": 0,
                    "company_name": "",
                    "from_date": "",
                    "to_date": "",
                    "previous_employee_id": "",
                    "designation_name": "",
                    "last_drawn_salary": 0,
                    "reason_for_change": "",
                    "experience_letter_file_id": "",
                    "relieving_letter_file_id": "",
                    "offer_letter_file_id": "",
                    "payslip_1_file_id": "",
                    "payslip_2_file_id": "",
                    "payslip_3_file_id": ""
                },
                inputs: [
                    {
                        label: "Company Name",
                        name: "company_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Experiances From",
                        name: "from_date",
                        col: "3",
                        type: "date",
                        required: true
                    },
                    {
                        label: "Experience Year",
                        name: "to_date",
                        col: "3",
                        type: "date",
                        required: true
                    },
                    {
                        label: "Previous EmpNo",
                        name: "previous_employee_id",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Designation",
                        name: "designation_name",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Last Drawn Salary",
                        name: "last_drawn_salary",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "Reason for Change",
                        name: "reason_for_change",
                        col: "3",
                        type: "text",
                        required: true
                    },
                    {
                        label: "",
                        name: "",
                        col: "3",
                        type: "",
                    },
                    {
                        label: "Upload Experience Letter",
                        name: "experience_letter_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                    {
                        label: "Upload Relieving Letter",
                        name: "relieving_letter_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                    {
                        label: "Upload Offer/Appointment Letter",
                        name: "offer_letter_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                    {
                        label: "Upload 1st months Payslip",
                        name: "payslip_1_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                    {
                        label: "Upload 2nd months Payslip",
                        name: "payslip_2_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                    {
                        label: "Upload 3rd months Payslip",
                        name: "payslip_3_file",
                        col: "3",
                        type: "file",
                        required: true
                    },
                ]
            }
        }
    },
    "step10": {
        pageTitle: "",
        getDataKey: "employee_medical_insurance_nomination",
        fieldData: {
            "Medical Insurance Nomination": {
                download: true,
                otherText: true,
                key: "employee_medical_insurance_nomination",
                deleteKey: "insurance_nomination_details_delete",
                apiEndpoint: "UPSERTEMPLOYEEMEDICALINSURANCENOMINATIONDETAIL",
                payload: {
                    "insurance_nomination_id": 0,
                    "family_id": 0
                },
                is_dynamic: true,
                inputs: [
                    {
                        label: "Include Yourself First",
                        name: "company_name",
                        col: "12",
                        type: "",
                        fieldHide: true
                    },
                    {
                        label: "Family Person Name",
                        name: "family_id",
                        col: "6",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true,
                        tableField: "member_name"
                    },
                    {
                        label: "Relation",
                        name: "family_relation",
                        hide: true
                    },
                    {
                        label: "Gender",
                        name: "gender",
                        hide: true
                    },
                    {
                        label: "Birth Date",
                        name: "date_of_birth",
                        hide: true
                    },
                    {
                        label: "Age",
                        name: "age",
                        hide: true
                    },
                    {
                        label: "Marital status",
                        name: "marital_status",
                        hide: true
                    }

                ]
            }
        }
    },
    "step11": {
        pageTitle: '',
        getDataKey: "employee_pf_details",
        fieldData: {
            "Provident Fund Declaration": {
                key: "employee_pf_declaration_details",
                apiEndpoint: "UPSERTEMPLOYEEEPFDECLARATIONDATA",
                payload: {
                    "epf_declaration_id": 0,
                    "epf_enrolled_date": "2025-07-31T10:34:17.552Z",
                    "first_epf_wages": 0,
                    "is_epf_member_before": true,
                    "is_epf_amount_withdrawn": true,
                    "is_pension_amount_withdrawn": true,
                    "is_withdrawn_before_join": true
                },
                inputs: [
                    {
                        label: "First EPF Member Enrolled Date",
                        name: "epf_enrolled_date",
                        col: "3",
                        type: "date",
                        required: true
                    },
                    {
                        label: "First Employment EPF Wages",
                        name: "first_epf_wages",
                        col: "3",
                        type: "number",
                        required: true
                    },
                    {
                        label: "Are you EPF Member before 01/09/2014",
                        name: "is_epf_member_before",
                        col: "3",
                        type: "select",
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    },
                    {
                        label: "If Yes, EPF Amount Withdrawn?",
                        name: "is_epf_amount_withdrawn",
                        col: "3",
                        type: "select",
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    },
                    {
                        label: "If Yes, EPS (Pension) Amount Withdrawn?",
                        name: "is_pension_amount_withdrawn",
                        col: "4",
                        type: "select",
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    },
                    {
                        label: "After Sep 2014 earned EPS (Pension) Amount Withdrawn before Join current Employer?",
                        name: "is_withdrawn_before_join",
                        col: "5",
                        type: "select",
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    }
                ]
            }

        }
    },
    "step12": {
        pageTitle: "",
        getDataKey: "employee_pf_nomination_declaration",
        fieldData: {
            "employee_pf_nomination": {
                key: "employee_pf_nomination",
                table: true,
                inputs: [
                    {
                        label: "Name (in Block Letters)",
                        name: "user_display_name"
                    },
                    {
                        label: "Father’s/Husband’s Name",
                        name: "father_or_husband_name"
                    },
                    {
                        label: "Date of birth ",
                        name: "birth_date"
                    },
                    {
                        label: "Sex",
                        name: "gender"
                    },
                    {
                        label: "Marital Status",
                        name: "marital_status"
                    },
                    {
                        label: "Account No.(PF/UAN Number)",
                        name: "uan_number"
                    },

                    {
                        label: "Address(Residential)",
                        name: "permanent_contact_address"
                    }
                ]
            },
            "Part A (EPF)": {
                isFormTable: true,
                subTitle: "I hereby nominate the person(s)/cancel the nominations made by me previously and nominate the person(s) mentioned below to receive the amount standing to my credit in the Employees Provident Fund, in the event of my death.",
                deleteKey: "efp_nomination_details_delete",
                apiEndpoint: "UPSERTEMPLOYEEEPFDETAILS",
                key: "employee_epf_part_a",
                payload: {
                    "efp_nomination_id": 0,
                    "family_id": 0,
                    "nominee_percentage": 0,
                    "is_nominee_minor": true,
                    "gardian_name": "",
                    "gardian_relationship_item_id": 0,
                    "gardian_address_data": "",
                    "is_residing_with_relative": true,
                    "residence_town": "",
                    "residence_state": ""
                },
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Nominee Percentage",
                        name: "nominee_percentage",
                        col: "3",
                        type: "number",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Is Nominee Minor",
                        name: "is_minor",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    },
                    {
                        label: "Guardian Name, Address and Relationship",
                        name: "guardian_name",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_minor",
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "residence_town",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                    {
                        label: "If' No' state Place of Residence State",
                        name: "residence_state",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                ]
            },
            "Part B (EPS) (Para 18)": {
                isFormTable: true,
                subTitle: "I hereby furnish below particulars of the members of my family who would be eligible to receive Widow/Childern Pension in the event of death.",
                deleteKey: "eps_nomination_1_details_delete",
                apiEndpoint: "UPSERTEMPLOYEEEPSNOMINATIONDETAILS",
                key: "employee_eps_part_1",
                payload: {
                    "eps_nomination_id": 0,
                    "eps_part_name": "partB",
                    "eps_family_id": 0,
                    "eps_is_residing_with_relative": true,
                    "eps_residence_town": "",
                    "eps_residence_state": ""
                },
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "eps_family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "eps_is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "eps_residence_town",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "eps_is_residing_with_relative",
                    },
                    {
                        label: "If' No' state Place of Residence State",
                        name: "eps_residence_state",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "eps_is_residing_with_relative",
                    },
                ]
            },
            "Part B EPS Part (II)": {
                isFormTable: true,
                subTitle: "I hereby nominate the following persons for receiving the monthly widow pension (admissible under para 16 2(a) (i) and (ii) of Employees’ Pension Scheme, 1995 in the event of my death without leaving any eligible family member for receiving Pension.",
                deleteKey: "eps_nomination_2_details_delete",
                apiEndpoint: "UPSERTEMPLOYEEEPSNOMINATIONDETAILS",
                key: "employee_eps_part_2",
                payload: {
                    "eps_nomination_id": 0,
                    "eps_part_name": "partII",
                    "eps_family_id": 0,
                    "eps_is_residing_with_relative": false,
                    "eps_residence_town": "",
                    "eps_residence_state": ""
                },
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "eps_family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "eps_is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "eps_residence_town",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "eps_is_residing_with_relative",
                    },
                    {
                        label: "If' No' state Place of Residence State",
                        name: "eps_residence_state",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "eps_is_residing_with_relative",
                    },
                ]
            }
        }
    },
    "step13": {
        pageTitle: "",
        getDataKey: "employee_esic_details",
        fieldData: {
            "Details of Nominee": {
                isFormTable: true,
                subTitle: "(c) Details of Nominee u/s 71 of ESI Act 1948/Rule-56(2) of ESI (Central) Rules, 1950 for payment of cash benefit in the event of death.",
                deleteKey: "esic_family_insurance_delete",
                apiEndpoint: "UPSERTEMPLOYEEESICFAMILYINSUREDDETAIL",
                key: "employee_esic_family_details",
                payload: {
                    "esic_family_insured_id": 0,
                    "family_id": 0,
                    "is_residing_with_relative": true,
                    "residence_address": ""
                }
                ,
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true,
                        tableField: "member_name"
                    },
                    {
                        label: "Relation",
                        name: "relation_name",
                        hide: true
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "residence_address",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                ]
            },
            "Family Particulars": {
                isFormTable: true,
                subTitle: "(D) Family Particulars of Insured person ",
                deleteKey: "esic_nominee_details_delete",
                apiEndpoint: "UPSERTEMPLOYEEESICNOMINEEDETAIL",
                key: "employee_esic_nominee_details",
                payload: {
                    "esic_id": 0,
                    "family_id": 0,
                    "is_residing_with_relative": true,
                    "residence_town": "",
                    "residence_state": ""
                },
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "residence_town",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                    {
                        label: "If' No' state Place of Residence State",
                        name: "residence_state",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                ]
            },
        }
    },
    "step14": {
        pageTitle: '',
        getDataKey: "employee_gratuity_details",
        fieldData: {

            "Gratuity Nomination": {
                deleteKey: "esic_gratutity_nominee_delete",
                key: "employee_gratuity_nominee",
                apiEndpoint: "UPSERTEMPLOYEEGRATUATITYNOMINEEDETAIL",
                payload: {
                    "esic_id": 0,
                    "family_id": 0,
                    "nominee_percentage": 0,
                    "is_residing_with_relative": true,
                    "residence_town": "",
                    "residence_state": ""
                },
                inputs: [
                    {
                        label: "Family Person Name",
                        name: "family_id",
                        col: "3",
                        type: "select",
                        required: true,
                        option: [],
                        is_API: true
                    },
                    {
                        label: "Nominee Percentage",
                        name: "nominee_percentage",
                        col: "3",
                        type: "number",
                        required: true,
                        option: [],
                    },
                    {
                        label: "Whether residing with him/her",
                        name: "is_residing_with_relative",
                        col: "3",
                        type: "select",
                        required: false,
                        option: [
                            { label: "Yes", value: false },
                            { label: "No", value: true },
                        ]
                    },
                    {
                        label: "If' No' state Place of Residence Town",
                        name: "residence_town",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                    {
                        label: "If' No' state Place of Residence State",
                        name: "residence_state",
                        col: "3",
                        type: "text",
                        required: false,
                        depand: "is_residing_with_relative",
                    },
                ]
            },
            "employee_common_details": {
                key: "employee_common_details",
                inputs: [
                    {
                        label: "Name of the employee in full",
                        name: "user_display_name",
                        hide: true
                    },
                    {
                        label: "Sex",
                        name: "gender",
                        hide: true
                    },
                    {
                        label: "Religion",
                        name: "religion_name",
                        hide: true
                    },
                    {
                        label: "Whether unmarried/married/widow/widower.",
                        name: "marital_status",
                        hide: true
                    },
                    {
                        label: "Department/Branch/Section where employed",
                        name: "department",
                        hide: true
                    },
                    {
                        label: "Date of appointment",
                        name: "joining_date",
                        type: "date",
                        hide: true
                    },
                    {
                        label: "Permanent Address",
                        name: "permanent_contact_address",
                        hide: true
                    },

                ]
            },
            "Declaration By Witnesses": {
                key: "employee_gratuity_witness",
                apiEndpoint: "UPSERTEMPLOYEEGRATUITYWITNESSDETAIL",
                deleteKey: "esic_gratutity_witness_delete",
                payload: {
                    "esic_id": 0,
                    "witness_name": "",
                    "witness_address": ""
                },
                inputs: [
                    {
                        label: "Witnesses Name",
                        name: "witness_name",
                        col: "3",
                        type: "text",
                        required: true,
                    },
                    {
                        label: "Witnesses Address",
                        name: "witness_address",
                        col: "3",
                        type: "textarea",
                        required: true,
                        option: [],
                    },
                ]
            }

        }
    },
    "step17": {
        pageTitle: '',
        getDataKey: "user_essence_details",
        apiEndpoint: "UPSERTEMPLOYEEESSENCEFORMDETAIL",
        fieldData: {
            "Essence Form": {
                key: "user_essence_details",
                otherText: true,
                subText: "Best Practices of Previous Company",
                payload: {
                    "what_you_like_previous_company": "string",
                    "what_key_take_aways_for_you": "string"
                },
                inputs: [
                    {
                        label: "What did you like most of your previous Company related to HR policies, initiatives taken, innovations, motivational factors, skills upgradation, trainings?",
                        name: "what_you_like_previous_company",
                        col: "12",
                        type: "textarea",
                        required: false,
                    },
                    {
                        label: "What is the key take aways for you, from your previous Company, which you would like to incorporate here?",
                        name: "what_key_take_aways_for_you",
                        col: "12",
                        type: "textarea",
                        required: false,
                    },
                ]
            }
        }

    }
}


























